<template>
  <div>
    <div v-if="loading" class="text-center">
      <b-spinner></b-spinner>
      <h4>Cargando</h4>
      <b-progress :value="10" :max="100" class="mt-1" show-progress animated></b-progress>
    </div>
    <div v-else-if="!submitted">
      <div class="form-group row">
        <label class="col-md-3 col-form-label">
          Archivos
        </label>
        <div class="col-md-9">
          <b-form-file v-model="excelFile" accept=".html, .png" multiple class="text-nowrap text-truncate"
            placeholder="Seleccione archivos en formato html." required size="md">
          </b-form-file>
        </div>
      </div>
      <div class="form-group row mt-3">
        <b-button variant="danger" class="ml-auto mr-2" @click="$emit('cancel')">Cancelar</b-button>
        <b-button variant='primary' class="mr-3" :disabled='!isFormValid()' @click="submitForm">Guardar</b-button>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-12">
          <div class="text-center">
            <h2 class="mt-0">
              <i class="mdi mdi-check-all"></i>
            </h2>
            <span v-if="error === null">
              <h3 class="mt-0">Carga subida!</h3>
            </span>
            <span v-else>
              <h3 class="mt-0">¡Error!</h3>
              <p class="w-75 mb-2 mx-auto">{{error}}</p>
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <b-button class="mr-2 ml-auto" variant="danger" @click="$emit('cancel')">Cerrar</b-button>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  components: {},
  props: {
  },
  data() {
    return {
      excelFile: [],
      loading: false,
      error: null,
      submitted: false,
    }
  },
  beforeMount() {
  },
  methods: {
    isFormValid() {
      if (this.excelFile.length > 0) return true
      return false
    },
    async submitForm() {
      if (!this.isFormValid()) {
        return false
      }
      this.loading = true
      let data = new FormData()
      data.append('csv_file', this.excelFile)
      await this.$http
        .post('/api/v1/debtor_contact_mass_uploads', data, {
          headers: {
            "Content-Type": "multipart/form-data"
          },
        })
        .then((response) => {
          console.log(response)
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.error = 'No tienes permiso para realizar esta acción.'
          } else {
            this.error = err.response.data.error
          }
        })
      this.excelFile = null
      this.loading = false
      this.submitted = true
      this.$emit("submit")
      return true
    },
  },
}
</script>


<style>

</style>

